import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { RegisterRequest, RegisterResponse } from '../../../../shared/types/routes/auth/v2';

/**
 * Creates a local (email + password) account via `POST /api/auth/register` and logs the new user in. The
 * response drives what comes next: an invited join goes to the dashboard, an unverified cloud signup to the
 * verify-code step, and everything else to onboarding.
 */
export function useRegister() {
  return useToastedMutation({
    mutationFn: async (body: RegisterRequest) =>
      (await post<RegisterRequest, RegisterResponse>('/api/auth/register', body)).data,
  });
}
